



























































import {Component, Prop, Vue} from 'vue-property-decorator';
import FileSystemObjectType from '@/enums/FileSystemObjectType';
import FileSystemObjectModel from '@/model/FileSystemObjectModel';
import Directory from '@/model/Directory';
import File from '@/model/File';
import Image from '@/model/Image';
import FileInspector from '@/components/FileInspector.vue';
import {FileManagerEvents} from '@/events';
import eventBus from '@/EventBus';
import Thumbnail from '@/components/Thumbnail.vue';

@Component({
	name: 'FileSystemObject',
	components: {
		Thumbnail
	}
})
export default class FileSystemObject extends Vue {
	private FileSystemObjectType = FileSystemObjectType;
	private File = File;
	private Image = Image;
	private Directory = Directory;
	private fileInspector: FileInspector;

	@Prop()
	private model: FileSystemObjectModel;

	private showObjectControl: boolean = false;

	constructor()
	{
		super();

		//we need $parent.$parent because parent is the transition-group component!
		this.fileInspector = this.$parent.$parent as FileInspector;
	}

	public onFileSystemObjectDragEnter(dataTransfer: any, nativeEvent: DragEvent)
	{
		if (!(this.model instanceof Directory))
		{
			//todo: indicate that drop isn't possible!
		}
	}

	public onFileSystemObjectDrop(dataTransfer: any)
	{
		const fileSystemObjectModel = dataTransfer.fileSystemObjectModel;

		if (fileSystemObjectModel && this.model instanceof Directory && fileSystemObjectModel !== this.model)
		{
			this.fileInspector.moveFileSystemObjectModel(fileSystemObjectModel, this.model);
		}
	}

	public onFileSystemObjectClicked()
	{
		if (this.model instanceof File)
		{
			eventBus.$emit(FileManagerEvents.fileSystemObjectClicked, {fileSystemObjectModel: this.model});
		}

		if (this.model instanceof Directory)
		{
			this.fileInspector.openDirectory(this.model);
		}
	}

	public onRenameClicked()
	{
		this.resetFileSystemObjectControl();

		this.fileInspector.renameFileSystemObjectModel(this.model);
	}

	public onResizeClicked()
	{
		this.resetFileSystemObjectControl();

		this.fileInspector.resizeImage(this.model as Image);
	}

	public onCopyClicked()
	{
		this.resetFileSystemObjectControl();

		this.fileInspector.copyFileSystemObjectModel(this.model);
	}

	public onDownloadClicked()
	{
		this.resetFileSystemObjectControl();

		this.fileInspector.downloadFileSystemObjectModel(this.model);
	}

	public onDeleteClicked()
	{
		if (confirm('Sind Sie sicher?'))
		{
			this.resetFileSystemObjectControl();

			this.fileInspector.deleteFileSystemObjectModel(this.model);
		}
	}

	private resetFileSystemObjectControl()
	{
		this.$store.dispatch('resetActionHint');
		this.showObjectControl = false;
	}
}
